import i18next from "i18next";
import { initReactI18next } from "react-i18next";

i18next
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "nl",
    interpolation: {
      escapeValue: false,
    },
  });

export const translationService = {
  addResourceBundle: (lang: string, namespace: string, resources: any) => {
    i18next.addResourceBundle(lang, namespace, resources);
  },
  changeLanguage: (lang: string) => {
    i18next.changeLanguage(lang);
  },
};

export default translationService;
